import { all, fork } from 'redux-saga/effects';
import user from "./user";
import ui from './ui';
import userPreferences from './userPreferences';
import userProduct from './userProduct';
import promo from './promo';
import ticket from './ticket';
import emailSubscription from './emailSubscription';
import shareWithFriend from './shareWithFriend';
import bookingManagement from './bookingManagement';
import payment from './payment';
import analytics from './analytics';
import activeCampaign from './activeCampaign';

export default function* rootSaga() {
  yield all([
    userPreferences(),
    fork(user),
    ui(),
    userProduct(),
    promo(),
    ticket(),
    emailSubscription(),
    shareWithFriend(),
    bookingManagement(),
    payment(),
    analytics(),
    activeCampaign()
  ]);
};
